import { Autocomplete, Box, TextField } from "@mui/material";
import { UUID } from "crypto";

const Campaign = ({ campaign }: { campaign: any }) => {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Autocomplete
          id="combo-box-demo"
          onInputChange={campaign.handleSearchChange}
          loading={campaign.CampaignsData.campaignsLoading}
          options={
            campaign.CampaignsData.CampaignsData
              ? [
                  ...(campaign.CampaignsData.CampaignsData?.map(
                    (campaign: { name: string; id: string | UUID }) => ({
                      label: campaign.name,
                      uid: campaign.id,
                    })
                  ) ?? []),
                ]
              : []
          }
          sx={{
            width: "100%",
          }}
          value={campaign.state as any}
          onChange={campaign.handleChangeCampaign}
          isOptionEqualToValue={(option, value) =>
            option.label === value?.label
          }
          renderInput={(params) => (
            <TextField {...params} label="Find Campaign" variant="outlined" />
          )}
        />
      </Box>
    </>
  );
};

export default Campaign;
